import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { TournamentTeamService } from '@core/services/tournament-team.service';
import { isPlatformBrowser } from '@angular/common';
import { componentDestroyed, Game, handleError, UntilDestroy } from '@mtgame/core';
import { getGameRoute } from '@config/routes';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from '@mtgame/ui';

@UntilDestroy
@Component({
  selector: 'mtg-tournament-team-games',
  templateUrl: './tournament-team-games.component.html',
  styleUrls: ['./tournament-team-games.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentTeamGamesComponent implements OnInit, OnDestroy {
  loaded = false;
  closedGames: Game[];
  futureGames: Game[];
  isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private tournamentTeamService: TournamentTeamService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.tournamentTeamService.games$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(games => {
        if (!games) {
          this.loaded = false;
          this.cdr.markForCheck();
          return;
        }
        this.closedGames = games.filter( g => g.isClosed).sort((a, b) => {
          if (a.datetime && b.datetime) {
            return a.datetime.getTime() > b.datetime.getTime() ? -1 : 1;
          }
          if (a.datetime) {
            return -1;
          }
          return 1;
        });
        this.futureGames = games.filter(g => !g.isClosed).sort((a, b) => {
          if (a.datetime && b.datetime) {
            return a.datetime.getTime() < b.datetime.getTime() ? -1 : 1;
          }
          if (a.datetime && !b.datetime) {
            return -1;
          }
          if (b.datetime && !a.datetime) {
            return 1;
          }
          if (a.tournamentStageId !== b.tournamentStageId) {
            return a.tournamentStageId < b.tournamentStageId ? -1 : 1;
          }
          if (!a.playoffNumber && !b.playoffNumber) {
            return a.tournamentTour < b.tournamentTour ? -1 : 1;
          }
          if (a.playoffNumber && b.playoffNumber) {
            return a.playoffNumber < b.playoffNumber ? -1 : 1;
          }
          return a.playoffNumber ? 1 : -1;
        });
        this.loaded = true;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
  }

  getGameRoute(gameId: number): string[] {
    return getGameRoute(gameId);
  }

  trackById(index: number, game: Game): number {
    return game.id;
  }
}
